import React from 'react';
import { motion } from 'framer-motion';

const SuccessModal = ({
  isOpen,
  onClose,
  employeeData,
  onAddAnother,
  onViewAllEmployees
}) => {
  if (!isOpen) return null;

  const { firstName, lastName, position, department } = employeeData || {};

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 source-sans-3">
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 10 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="bg-white rounded-xl p-6 max-w-md w-full shadow-xl"
      >
        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary-600" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
        </div>

        <h2 className="text-xl font-bold text-primary-800 mb-2 text-center">Employee Added Successfully!</h2>
        
        {employeeData && (
          <div className="bg-primary-50 rounded-lg p-4 mb-5 mt-4">
            <div className="flex items-center mb-3">
              <div className="w-10 h-10 rounded-full bg-primary-600 flex items-center justify-center text-white text-lg font-semibold">
                {firstName?.[0]}{lastName?.[0]}
              </div>
              <div className="ml-3">
                <h3 className="font-semibold text-primary-800">{firstName} {lastName}</h3>
                <p className="text-sm text-primary-600">{position} {department ? `• ${department}` : ''}</p>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              The employee has been added to your system and can now be managed through the employee dashboard.
            </p>
          </div>
        )}
        
        <p className="text-gray-600 mb-6 text-center">What would you like to do next?</p>
        
        <div className="grid grid-cols-1 gap-3">
          <button
            onClick={onAddAnother}
            className="px-4 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium flex items-center justify-center"
          >
            <svg className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Another Employee
          </button>
          
          <button
            onClick={onViewAllEmployees}
            className="px-4 py-3 bg-white border border-primary-300 text-primary-700 rounded-lg hover:bg-primary-50 transition-colors font-medium flex items-center justify-center"
          >
            <svg className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            View All Employees
          </button>
          
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-500 hover:text-gray-700 transition-colors font-medium text-sm"
          >
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default SuccessModal;